import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Bank } from '../model/bank';
import { Enterprise } from '../model/enterprise';
import { User } from '../model/user';

@Injectable({ providedIn: 'root' })
export class StorageService {
    private readonly PROFILE_ENTERPRISE_KEY = 'profileEnterprise';
    private readonly PROFILE_USER_KEY = 'profileUser';

    public user = new BehaviorSubject<User | null>(null);
    public profileUser = new BehaviorSubject<User | null>(this.getItem<User>(this.PROFILE_USER_KEY));
    public profileEnterprise = new BehaviorSubject<Enterprise | null>(
        this.getItem<Enterprise>(this.PROFILE_ENTERPRISE_KEY)
    );

    public bankList = new BehaviorSubject<Bank[] | null>(null);
    public bankNameList = new BehaviorSubject<string[] | null>(null);
    public cityDropdown = new BehaviorSubject<string[] | null>(null);
    public idTypeDropdown = new BehaviorSubject<string[] | null>(null);
    public statusDropdown = new BehaviorSubject<string[] | null>(null);
    public provinceDropdown = new BehaviorSubject<string[] | null>(null);
    public accountTypeDropdown = new BehaviorSubject<string[] | null>(null);
    public transactionTypeDropdown = new BehaviorSubject<string[] | null>(null);
    public transactionStatusDropdown = new BehaviorSubject<string[] | null>(null);

    constructor() { }

    getItem<T>(key: string): T | null {
        const value = localStorage.getItem(key);

        if (!value) {
            return null;
        }

        return JSON.parse(value) as T;
    }

    setItem<T>(key: string, val: T): void {
        localStorage.setItem(key, JSON.stringify(val));
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    initializeProfileUser(): void {
        this.profileUser.next(null);
        this.removeItem(this.PROFILE_USER_KEY);
    }

    setProfileUser(user: User | null): void {
        this.profileUser.next(user);

        if (user === null) {
            this.removeItem(this.PROFILE_USER_KEY);
            return;
        }

        this.setItem(this.PROFILE_USER_KEY, user);
    }

    getProfileUser(): User | null {
        return this.profileUser.value;
    }

    setEnterpriseProfile(enterprise: Enterprise | null): void {
        this.profileEnterprise.next(enterprise);

        if (enterprise === null) {
            this.removeItem(this.PROFILE_ENTERPRISE_KEY);
            return;
        }

        this.setItem(this.PROFILE_ENTERPRISE_KEY, enterprise);
    }

    getEnterpriseProfile(): Enterprise | null {
        return this.profileEnterprise.value;
    }

    initializeEnterpriseProfile(): void {
        this.profileEnterprise.next(null);
        this.removeItem(this.PROFILE_ENTERPRISE_KEY);
    }
}
